import React, { useState } from "react";
import { Stack, Typography } from "@mui/material";
import { makeStyles, useTheme } from "../../theme/Theme";
import { Breakpoints } from "../../dto/ApplicationDTO";
import { ManageFundsHeader } from "../manage-funds";
import { Loader } from "../ui/Loader";

const useStyles = makeStyles((theme) => ({
  subtitle: {
    color: theme.palette.total.main,
    marginTop: "8px !important",
    marginBottom: "24px !important",
  },
  accountTypeButton: {
    color: theme.palette.cow.main,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: 16,
    marginBottom: 16,
    textAlign: "left",
    borderRadius: 20,
    border: `1px solid ${theme.palette.grape.main}`,
    backgroundColor: "transparent",
    boxShadow: "none",
    textTransform: "none",
    width: "100%",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.8)",
    },
    "&:disabled": {
      opacity: 0.5,
      cursor: "not-allowed",
    },
  },
  root: {
    [theme.breakpoints.up(Breakpoints.Mobile)]: {
      marginTop: 14,
    },
    [theme.breakpoints.up(Breakpoints.Tablet)]: {
      marginTop: 60,
    },
  },
  wrapperBack: {
    marginBottom: 8,
  },
  angleLeftIcon: {
    width: 24,
    height: 24,
    transform: "rotate(180deg)",
  },
}));

interface PickAccountTypeProps {
  availableAccountTypes: Auth.AvailableAccountTypes[];
  onSelect: (accountType: Auth.AvailableAccountTypes) => Promise<void>;
  onBackClick: () => void;
}

export function PickAccountType({
  availableAccountTypes,
  onSelect,
  onBackClick,
}: PickAccountTypeProps) {
  const [isLoading, setIsLoading] = useState(false);
  const classes = useStyles();
  const theme = useTheme();

  const handleSelect = async (accountType: Auth.AvailableAccountTypes) => {
    setIsLoading(true);
    await onSelect(accountType);
    setIsLoading(false);
  };

  return (
    <Stack className={classes.root}>
      <ManageFundsHeader classNamesProps={classes.wrapperBack} onBack={onBackClick}>
        <Typography variant="h1">Выберите тип профиля</Typography>
      </ManageFundsHeader>
      <Typography className={classes.subtitle} variant="text2">
        У вас есть несколько аккаунтов. Выберите тот, в который хотите войти
      </Typography>

      {availableAccountTypes.map((accountType) => (
        <button
          key={accountType.id}
          className={classes.accountTypeButton}
          onClick={() => handleSelect(accountType)}
          disabled={isLoading}
        >
          {isLoading ? (
            <Loader size={16} color={theme.palette.grape.main} />
          ) : (
            <>
              <Typography variant="button">{accountType.name}</Typography>
            </>
          )}
        </button>
      ))}
    </Stack>
  );
}
